export enum WellKnownCustomPropertyTypes {
    acn = 1,
    abn = 2,
}
